import React from 'react';

const UserRow = (props) => {
  return (
    <div>

    </div>
  )
}

export default UserRow;